



































import _ from 'lodash'
import { Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import ScheduleDetail from '@/components/today/ScheduleDetail.vue'
import PatientDetail from '@/components/today/PatientDetail.vue'
import ScheduleLog from '@/components/today/ScheduleLog.vue'
import { BaseForm } from '@/services/BaseForm'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import { IJob } from '@/store/modules/views/job/states'
import { ISchedule } from '@/store/modules/views/schedule/states'
import moment from 'moment'

@Component({
  components: {
    ScheduleDetail,
    PatientDetail,
    ScheduleLog,
  },
})
export default class Today extends BaseForm<any> {
  private loading = false
  private today: ISchedule & {job: IJob} = null
  private schedule: ISchedule
  private scheduleView: string

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('job/jobById')
  private jobById!: IJob

  @Action('components/updateTitlePage')
  private updateTitlePage!: (title: string) => void

  @Action('job/getJobById')
  private getJobById!: (options: {}) => void

  private async mounted() {
    this.updateTitlePage('รายละเอียดงานช่วงเวลานี้')
    this.doAssignSchedule()
    if (
      this.schedule && this.schedule.endDate && this.schedule.endTime &&
      (!this.schedule.logs || (this.schedule.logs.length < 1)) &&
      moment().isAfter(`${this.schedule.endDate} ${this.schedule.endTime}`)
    ) {
      this.updateSnackbar({ txt: 'กรุณาลงเวลางานก่อนเวลา หรือในเวลางาน', type: 'error' })
    }
  }

  private beforeDestroy() {
    if (this.$route.params.page !== 'today') {
      localStorage.removeItem('scheduleView')
    }
  }

  private async doAssignSchedule() {
    this.scheduleView = localStorage.getItem('scheduleView')
    if ((this.scheduleView && this.scheduleView === '') && !this.profile.schedule) {
      this.$router.push('/action/profile')
    } else {
      this.schedule = this.scheduleView && this.scheduleView !== ''
        ? JSON.parse(this.scheduleView)
        : this.profile.schedule
    }
    if (this.schedule && this.schedule.jobId) {
      await this.getJobById({ _id: this.schedule.jobId })
    }
  }

  @Watch('profile', { deep: true })
  private handleChangeProfile() {
    this.doAssignSchedule()
  }

  @Watch('jobById', { deep: true })
  private obUpdateJob() {
    this.today = {
      ...this.schedule,
      job: this.jobById && !_.isEmpty(this.jobById) && !_.isNull(this.jobById) ? this.jobById : undefined,
    }
  }
}
